import React, { useState, useRef, useEffect } from 'react';

const ManagerNavigation = ({ activeTab, onTabChange, restaurant, managerName, onLogout }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const menuRef = useRef(null);

  const tabs = [
    { id: 'manager-dashboard', label: 'My Dashboard' },
    { id: 'pos-dashboard', label: 'POS Dashboard' },
    { id: 'billing-payment', label: 'Quick Billing' },
    { id: 'orders', label: 'Orders' },
    { id: 'invoices', label: 'Invoices' },
    { id: 'reports', label: 'Reports' },
    { id: 'crm', label: 'Customers' },
    { id: 'inventory', label: 'Inventory' },
    { id: 'menu', label: 'Menu Management' },
    { id: 'waiters', label: 'Waiter Management' },
    { id: 'preview', label: 'Menu Preview' },
  ];

  const activeTabObj = tabs.find(t => t.id === activeTab);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setShowMenu(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleTabSelect = (id) => { onTabChange(id); setShowMenu(false); };

  return (
    <>
      <div style={{
        position: 'sticky', top: 0, zIndex: 100,
        background: 'rgba(255,255,255,0.97)',
        backdropFilter: 'blur(20px)',
        borderBottom: '1px solid rgba(99,102,241,0.15)',
        padding: '12px 0',
      }}>
        <div style={{ width: '100%', padding: '0 20px', boxSizing: 'border-box' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

            {/* Logo + restaurant name */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <img
                src="https://i.ibb.co/hF3Q8YrX/menuron-high-resolution-logo.png"
                alt="Menuron"
                style={{ height: '52px', filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.1))' }}
              />
              <div>
                <h1 style={{
                  margin: '0 0 2px 0', fontSize: '1.4rem', fontWeight: '700',
                  background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                  WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                }}>
                  {restaurant?.name}
                </h1>
                <p style={{ margin: 0, color: '#888', fontSize: '0.82rem' }}>
                  Manager · {managerName}
                </p>
              </div>
            </div>

            {/* Right: current tab pill + hamburger */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              {activeTabObj && (
                <div style={{
                  padding: '6px 14px',
                  background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                  color: 'white', borderRadius: '20px',
                  fontSize: '0.85rem', fontWeight: '700',
                }}>
                  {activeTabObj.label}
                </div>
              )}

              <div ref={menuRef} style={{ position: 'relative' }}>
                <button
                  onClick={() => setShowMenu(v => !v)}
                  style={{
                    background: showMenu ? 'linear-gradient(135deg, #6366f1, #8b5cf6)' : 'transparent',
                    border: '2px solid ' + (showMenu ? 'transparent' : '#e5e7eb'),
                    borderRadius: '10px', padding: '8px 12px', cursor: 'pointer',
                    display: 'flex', flexDirection: 'column', gap: '5px', transition: 'all 0.2s',
                  }}
                  aria-label="Menu"
                >
                  {[0, 1, 2].map(i => (
                    <span key={i} style={{
                      display: 'block', width: '22px', height: '2px',
                      background: showMenu ? 'white' : '#555',
                      borderRadius: '2px', transition: 'all 0.2s',
                    }} />
                  ))}
                </button>

                {showMenu && (
                  <div style={{
                    position: 'absolute', top: 'calc(100% + 8px)', right: 0,
                    background: 'white', borderRadius: '14px',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
                    border: '1px solid rgba(0,0,0,0.08)',
                    minWidth: '220px', overflow: 'hidden', zIndex: 200,
                  }}>
                    <div style={{ padding: '8px' }}>
                      {tabs.map(tab => (
                        <button
                          key={tab.id}
                          onClick={() => handleTabSelect(tab.id)}
                          style={{
                            width: '100%',
                            background: activeTab === tab.id ? 'linear-gradient(135deg, #6366f1, #8b5cf6)' : 'transparent',
                            color: activeTab === tab.id ? 'white' : '#333',
                            border: 'none', borderRadius: '8px',
                            padding: '10px 14px', fontSize: '0.92rem',
                            fontWeight: activeTab === tab.id ? '700' : '500',
                            cursor: 'pointer', textAlign: 'left', transition: 'all 0.15s',
                          }}
                          onMouseOver={e => { if (activeTab !== tab.id) e.currentTarget.style.background = '#f3f4f6'; }}
                          onMouseOut={e => { if (activeTab !== tab.id) e.currentTarget.style.background = 'transparent'; }}
                        >
                          {tab.label}
                        </button>
                      ))}
                    </div>
                    <div style={{ borderTop: '1px solid #f3f4f6', padding: '8px' }}>
                      <button
                        onClick={() => { setShowMenu(false); setShowLogoutConfirm(true); }}
                        style={{
                          width: '100%', background: 'transparent', color: '#dc2626',
                          border: 'none', borderRadius: '8px', padding: '10px 14px',
                          fontSize: '0.92rem', fontWeight: '600', cursor: 'pointer', textAlign: 'left',
                        }}
                        onMouseOver={e => e.currentTarget.style.background = '#fee2e2'}
                        onMouseOut={e => e.currentTarget.style.background = 'transparent'}
                      >
                        Logout
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showLogoutConfirm && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
        }}>
          <div style={{ background: 'white', padding: '30px', borderRadius: '15px', maxWidth: '400px', width: '90%', textAlign: 'center' }}>
            <h3 style={{ margin: '0 0 20px 0', color: '#333', fontSize: '1.4rem' }}>Confirm Logout</h3>
            <p style={{ margin: '0 0 25px 0', color: '#666' }}>Are you sure you want to logout?</p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button
                onClick={() => setShowLogoutConfirm(false)}
                style={{ padding: '12px 24px', border: '2px solid #6c757d', backgroundColor: 'transparent', color: '#6c757d', borderRadius: '8px', cursor: 'pointer', fontSize: '1rem' }}
              >Cancel</button>
              <button
                onClick={() => { setShowLogoutConfirm(false); onLogout(); }}
                style={{ padding: '12px 24px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '1rem' }}
              >Logout</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ManagerNavigation;
